var _style, _path, _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoNegative(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "489 -11.3 1769.8 634.3",
    style: {
      enableBackground: "new 489 -11.3 1769.8 634.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2113.9,434.3l-5.7-0.5c-9.2-0.8-16.2-8.6-16-17.9l4.7-273c2.1-22.4,21.9-39,44.4-36.9v0 c22.4,2.1,39,21.9,36.9,44.4l-45.1,269.2C2131.4,428.8,2123.1,435.2,2113.9,434.3z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 2107,
    cy: 478.1,
    r: 27.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M716.3,231C642.7,231,583,290.7,583,364.3s59.7,133.3,133.3,133.3S849.6,438,849.6,364.3S789.9,231,716.3,231z  M717.7,426.2c-34.9,0-63.3-28.3-63.3-63.3c0-34.9,28.3-63.3,63.3-63.3c34.9,0,63.3,28.3,63.3,63.3 C780.9,397.9,752.6,426.2,717.7,426.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1279.5,231c-73.6,0-133.3,59.7-133.3,133.3s59.7,133.3,133.3,133.3s133.3-59.7,133.3-133.3 S1353.1,231,1279.5,231z M1278.1,426.2c-34.9,0-63.3-28.3-63.3-63.3c0-34.9,28.3-63.3,63.3-63.3s63.3,28.3,63.3,63.3 C1341.4,397.9,1313.1,426.2,1278.1,426.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1941.5,246.7c-13.1-5.4-27.4-8.3-42.4-8.3c-18.4,0-35.7,4.4-51,12.2V231h-69.8h0v262.1h0v0h69.8v0v-42.5 v-96.3c0-25.9,21-46.8,46.8-46.8c24.2,0,44.1,18.3,46.6,41.8v10v95.3v38.6h69.8V350.6C2011.3,303.6,1982.5,263.4,1941.5,246.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1652.2,364.7 1651.7,366.3 1610,231 1582.2,231 1554.3,231 1512.6,366.3 1512.1,364.7 1466,231  1392.3,231 1481.6,491.5 1541.3,491.5 1548,469.9 1564.2,420.7 1564.3,420.6 1564.6,419.7 1582.2,366.4 1599.8,419.7 1600.1,420.6  1600.1,420.7 1616.4,469.9 1623,491.5 1682.7,491.5 1772,231 1698.3,231  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1054.8,246.2c-18.5-9.7-39.6-15.2-61.9-15.2c-73.6,0-133.3,59.7-133.3,133.3s59.7,133.3,133.3,133.3 c22.3,0,43.4-5.5,61.9-15.2c42.4-22.3,71.4-66.8,71.4-118.1V153.4l-71.4-39.4V246.2z M991.5,426.2c-34.9,0-63.3-28.3-63.3-63.3 c0-34.9,28.3-63.3,63.3-63.3c34.9,0,63.3,28.3,63.3,63.3C1054.8,397.9,1026.5,426.2,991.5,426.2z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNegative);
export default __webpack_public_path__ + "static/media/logo_negative.ea14b488.svg";
export { ForwardRef as ReactComponent };